import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { useMenuContext } from '../../state'
import { primary } from '../../styles/Colors'
import { size } from '../../styles/Media'
import { spacing } from '../../styles/Rythms'
import Search from '../search'
import NavItemGroup from './NavItemGroup'

const DesktopNavLinks = ({ currentCategory }) => {
  const { closeMenu, isMenuOpen } = useMenuContext()
  return (
    <NavLinksWrapper className="nav-links" isMenuOpen={isMenuOpen}>
      <NavItemGroup
        current={currentCategory === 'bourse'}
        name="Bourse"
        categoryPath="bourse"
        noun="la "
        navItems={{
          subCategories: [
            {
              name: 'investissement-socialement-responsable',
              label: 'Investissement Socialement Responsable',
            },
            {
              name: 'investir-en-actions',
              label: 'Investir en actions',
            },
            {
              name: 'etf-trackers',
              label: 'Trackers (ETF)',
            },
            {
              name: 'pea',
              label: 'Plan Épargne Actions (PEA)',
            },
            {
              name: 'compte-titres-ordinaire',
              label: 'Compte-titres ordinaire',
            },
          ],
          reviews: [
            {
              title: 'Trade Republic : avis & test du courtier aux petits frais',
              path: '/bourse/trade-republic-avis/',
            },
            {
              title: 'Avis sur DEGIRO : tout savoir sur ce courtier en ligne',
              path: '/bourse/avis-degiro/',
            },
            {
              title: 'Avis sur Scalable Capital : tout savoir sur ce courtier en ligne',
              path: '/bourse/scalable-capital-avis/',
            },
          ],
        }}
      />
      <NavItemGroup
        name="Immobilier"
        current={currentCategory === 'immobilier'}
        categoryPath="immobilier"
        noun="l'"
        navItems={{
          subCategories: [
            {
              name: 'investissement-locatif',
              label: 'Investissement locatif',
            },
            {
              name: 'scpi',
              label: 'SCPI',
            },
          ],
          reviews: [
            {
              title:
                'Beanstock : avis sur la plateforme qui trouve et gère votre investissement locatif',
              path: '/immobilier/beanstock-avis/',
            },
            {
              title: "Bevouac : notre avis sur le service d'investissement locatif clé en main",
              path: '/immobilier/bevouac-avis/',
            },
            {
              title: 'Avis sur Louve Invest : bon plan pour investir en SCPI ?',
              path: '/immobilier/louve-invest-avis/',
            },
          ],
        }}
      />
      <NavItemGroup
        name="Épargne"
        current={currentCategory === 'epargne'}
        categoryPath="epargne"
        noun="l'"
        navItems={{
          subCategories: [
            {
              name: 'budget',
              label: 'Budget',
            },
            {
              name: 'banque',
              label: 'Banque',
            },
            // {
            //   name: 'livrets-bancaires',
            //   label: 'Livrets bancaires',
            // },
            // {
            //   name: 'retraite',
            //   label: 'Retraite',
            // },
            // {
            //   name: 'independance-financiere',
            //   label: 'Indépendance financière',
            // },
            {
              name: 'revenus',
              label: 'Revenus',
            },
          ],
          reviews: [
            {
              title: 'Avis sur Moka : l’app pour épargner & investir automatiquement',
              path: '/epargne/avis-moka-application/',
            },
            {
              title: 'Avis Boursorama Banque : tout savoir avant d’ouvrir un compte',
              path: '/epargne/avis-boursorama-banque/',
            },
          ],
        }}
      />

      <NavItemGroup
        name="Placements"
        current={currentCategory === 'placements'}
        categoryPath="placements"
        noun="les "
        navItems={{
          subCategories: [
            {
              name: 'assurance-vie',
              label: 'Assurance-Vie',
            },
            {
              name: 'plan-epargne-retraite',
              label: 'Plan Épargne Retraite (PER)',
            },
            {
              name: 'robo-advisors',
              label: 'Robo-advisors',
            },
            {
              name: 'cryptomonnaies',
              label: 'Cryptomonnaies',
            },
            {
              name: 'placements-atypiques',
              label: 'Placements atypiques',
            },
            // {
            //   name: 'epargne-salariale',
            //   label: 'Épargne salariale',
            // },
            {
              name: 'compte-a-terme',
              label: 'Compte à terme',
            },
          ],
          reviews: [
            {
              title: 'Finary : avis sur la plateforme pour suivre vos placements simplement',
              path: '/placements/avis-finary/',
            },
            {
              title: 'Yomoni : avis sur la plateforme pour “mieux investir” votre argent',
              path: '/placements/yomoni-avis/',
            },
            {
              title: 'Goodvest : tout savoir sur l’assurance vie responsable',
              path: '/placements/avis-goodvest/',
            },
            {
              title: 'Avis sur Nalo : l’assurance-vie personnalisée (2022)',
              path: '/placements/avis-nalo/',
            },
            {
              title: 'Caravel : avis sur le Plan Épargne Retraite responsable',
              path: '/placements/caravel-avis-per/',
            },
          ],
        }}
      />
      <li>
        <LinkGuide to="/guide/" className="guide" title="Lien vers le guide" onClick={closeMenu}>
          Guide
        </LinkGuide>
      </li>
      <li>
        <LinkBoutique
          to="/ressources/"
          className="ressources"
          title="Lien vers les ressources"
          onClick={closeMenu}
        >
          Ressources
        </LinkBoutique>
      </li>
      <li className="search-bar">
        <Search />
      </li>
    </NavLinksWrapper>
  )
}

export default DesktopNavLinks

const LinkGuide = styled(Link)`
  background: var(--secondary1-40);
  color: #fff;
  padding: ${spacing[1]} ${spacing[3]};
  border-radius: 4px;
  transition: all 50ms linear;
  @media screen and (max-width: ${size.laptop}) {
    margin-left: ${spacing[6]};
  }

  :hover {
    background: var(--secondary1-60);
  }
`

const LinkBoutique = styled(Link)`
  background: var(--secondary1-10);
  color: var(--neutral90);
  padding: ${spacing[1]} ${spacing[3]};
  border-radius: 4px;
  transition: all 50ms linear;
  font-weight: normal;
  @media screen and (max-width: ${size.laptop}) {
    margin-left: ${spacing[6]};
  }

  :hover {
    background: var(--secondary1-20);
  }
`

const NavLinksWrapper = styled.ul`
  list-style: none;
  display: flex;

  li {
    font-size: var(--font-sm);
    padding: ${spacing[2]};
    margin: 0 !important;
  }

  li a {
    font-weight: 400;
  }

  @media screen and (max-width: ${size.laptop}) {
    width: 100%;
    padding-top: ${spacing[10]};
    flex-direction: column;
    max-width: 600px;
    padding-top: 2.5rem;
    margin: 1rem auto 4rem;
    li {
      padding: ${spacing[3]};
      padding-left: 0;
      margin: 0 !important;
      font-weight: 600;
    }

    .search-bar {
      order: -1;
      align-self: center;
    }
  }

  @media screen and (min-width: ${size.laptop}) {
    align-items: baseline;

    li:not(:last-child) {
      margin-right: ${spacing[6]};
    }
  }

  button {
    background: transparent;
    outline: none;
    border: none;
    cursor: pointer;
    ${(props) =>
      props.isMenuOpen &&
      `
      margin-top: ${spacing[3]};
    `}
  }
`

export const NavLink = styled(Link)`
  position: relative;
  color: var(--text);
  text-decoration: none;
  font-size: var(--font-lg);

  .guide {
    margin: 1rem;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 5px;
    bottom: 0;
    height: 10px;
    z-index: -1;
    width: 0;
    background: ${primary[50]};
    transition: width 150ms linear;
  }

  &:hover:not(.active-category)::before {
    //width: 100%;
  }
`
